
import { AuthModule } from "@/store/modules/auth";
import { ErrorMessage, Field, Form, useField, useForm } from "vee-validate";
import { defineComponent, onBeforeMount, ref } from "vue";
import { useI18n } from "vue-i18n/index";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";
import * as Yup from "yup";

interface Login {
  username: string;
  password: string;
}

export default defineComponent({
  name: "sign-in",
  components: {
    Field,
    Form,
    ErrorMessage,
  },

  setup() {
    const { t, te } = useI18n();
    const i18n = (text) => (te(text) ? t(text) : text);

    const store = useStore();
    const router = useRouter();
    const authModule = getModule(AuthModule, store);

    const submitButton = ref<HTMLButtonElement | null>(null);

    //Create form validation object
    const login = Yup.object().shape({
      username: Yup.string().required().label(i18n("authSigninUsernameLabel")),
      password: Yup.string()
        .min(8, i18n("authSigninPasswordlength"))
        .required()
        .label(i18n("authSigninPasswordLabel")),
    });

    useForm<Login>({
      validationSchema: login,
    });

    const { value: password, resetField: resetPassword } = useField("password");

    const passwordInput = ref<HTMLElement>();

    //Asi se crea reactiva
    const messageError = ref<string>("");

    onBeforeMount(() => {
      if (authModule.isAuthenticated) {
        router.push("/perfil");
      }
    });

    //Form submit function
    const onSubmitLogin = (values) => {
      // Clear existing errors
      authModule.logout();

      if (submitButton.value) {
        // eslint-disable-next-line
        submitButton.value!.disabled = true;
        // Activate indicator
        submitButton.value.setAttribute("data-kt-indicator", "on");
      }

      // Send login request
      authModule
        .login(values)
        .then(() => {
          router.push({ name: "perfil" });
        })
        .catch(() => {
          messageError.value = i18n("authSigninInvalidLogin");
          resetPassword();
          passwordInput.value?.focus();
        });

      //Deactivate indicator
      submitButton.value?.removeAttribute("data-kt-indicator");
      // eslint-disable-next-line
      submitButton.value!.disabled = false;
    };

    return {
      onSubmitLogin,
      login,
      submitButton,
      messageError,
      password,
      passwordInput,
    };
  },
});
